<mat-expansion-panel class="beleg" [expanded]="true" hideToggle="">
  <mat-expansion-panel-header class="beleg-component">
    <mat-panel-title>
      @if (!isMandatory()) {
        {{
          'new_antrag.label.beleg_title'
            | translate
              : {
                  seiten: beleg().seiten.length,
                  belegNo: belegIndex() + 1,
                }
        }}
      } @else {
        &#9733;
        {{
          'new_antrag.label.mandatory_title'
            | translate
              : {
                  current: beleg().seiten.length,
                  needed: pagesNeeded(),
                }
        }}
      }
      <small
        >&nbsp;({{ beleg() | currentBelegSize: beleg().seiten.length | async | bToMb | number: '1.1-1' }} MB)</small
      >
    </mat-panel-title>

    <div class="icon-panel">
      @if (!isMandatory() && canRemoveBeleg()) {
        <button
          #moveUpBtn
          [disabled]="isFirst()"
          [attr.aria-label]="'new_antrag.label.move_beleg_to_top' | translate"
          (keydown)="$event.stopPropagation()"
          (click)="moveToTop($event, moveUpBtn)"
          mat-icon-button>
          <mat-icon class="material-icons"> vertical_align_top </mat-icon>
        </button>
        <button
          [attr.aria-label]="'new_antrag.label.delete_beleg' | translate"
          (keydown)="$event.stopPropagation()"
          (click)="deleteMe($event)"
          mat-icon-button>
          <mat-icon class="material-icons">delete</mat-icon>
        </button>
      }
    </div>
  </mat-expansion-panel-header>

  <div class="item-wrapper">
    @for (item of beleg().seiten; track item.id; let j = $index) {
      <div class="pseudo-li">
        <img [src]="item.thumb" [alt]="'a11y.image.preview' | translate: { position: j + 1 }" width="60" height="84" />
        <div class="actions">
          <button
            class="zoom"
            [attr.aria-label]="'label.zoom' | translate"
            (click)="openImage(item)"
            title="{{ 'label.zoom' | translate | uppercase }}">
            <i class="material-icons"> zoom_in </i>
          </button>
          <button
            class="delete"
            [attr.aria-label]="'label.remove' | translate"
            (click)="removeFileFromBeleg(item)"
            title="{{ 'label.remove' | translate | uppercase }}">
            <i class="material-icons"> delete </i>
          </button>
        </div>
      </div>
    }
  </div>

  <mat-action-row>
    <button [disabled]="hasEnoughPages()" (click)="addSeiteToBeleg()" mat-flat-button color="primary">
      {{ 'new_antrag.label.add_new_page' | translate }}
    </button>
  </mat-action-row>
</mat-expansion-panel>
